import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import type { VisualizationType } from '@tempo-io/roadmap-dto';
import { getAllVisualizationsQueryOptions } from '@/lib/queries/roadmapping/useVisualization';
import { getLastVisitedVisualization } from './lastVisited';

export async function redirectToRoadmapVisualizationOfType({
  type,
  org,
  roadmapId,
  viewId,
  queryClient,
}: {
  type?: VisualizationType;
  org: string;
  roadmapId: number;
  viewId: number;
  queryClient: QueryClient;
}): Promise<void> {
  // Fetch visualizations using React Query cache (shared with components)
  const visualizations = await queryClient.ensureQueryData(
    getAllVisualizationsQueryOptions(viewId),
  );

  const preferredType = type ?? getLastVisitedVisualization(viewId);
  const firstVisualization = preferredType
    ? (visualizations.find((v) => v.type === preferredType) ?? visualizations[0])
    : visualizations[0];

  // Redirect to first visualization if any exist
  if (firstVisualization) {
    throw redirect({
      to: `/org/$org/roadmaps/$roadmapId/view/$viewId/${firstVisualization.type}`,
      params: { org, roadmapId, viewId },
      replace: true,
    });
  }
}
